import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { environment } from "src/environments/environment";
import { TranslationService } from "../services/translation.service";

export const baseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const translationService = inject(TranslationService);
  const baseUrl = environment.BASE_URL;

  const modifiedRequest = request.clone({
    url: `${baseUrl}${request.url}`,
    headers: request.headers.set("Accept-Language", translationService.activeLang().code),
  });

  return next(modifiedRequest);
};
